import { Group, GroupType } from '@/types/api/group';

// prettier-ignore
export function groupLabel(type: GroupType) {
  return function (property: keyof Group) {
    switch (property) {
      case 'id':               return 'Grupp-ID';
      case 'groupName':        return groupNameLabel(type);
      case 'organizationName': return organizationNameLabel(type);
      case 'groupType':        return 'Typ';
      default:                 return "Okänd"
    }
  };
}

// prettier-ignore
export function groupNameLabel(type: GroupType) {
  switch (type) {
    case GroupType.Association: return 'Beteckning';
    case GroupType.SchoolClass: return 'Klassbeteckning';
    case GroupType.SportsTeam:  return 'Lagbeteckning';
  }
}

// prettier-ignore
export function organizationNameLabel(type: GroupType) {
  switch (type) {
    case GroupType.Association: return 'Förening';
    case GroupType.SchoolClass: return 'Skola';
    case GroupType.SportsTeam:  return 'Klubb';
  }
}

// prettier-ignore
export function groupTypeLabel(type: GroupType) {
  switch (type) {
    case GroupType.Association: return "Förening";
    case GroupType.SchoolClass: return "Skolklass";
    case GroupType.SportsTeam:  return "Idrottslag";
    default:                    return "Okänt"
  }
}
